import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_GUESS_THE_ORDER_ACTIVITY from '../../queries/activities/guess-the-order-query';
import { GuessTheOrderActivity as GuessTheOrder } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';

const DEFAULT_BOOK_EDTION = 2022;

export type GuessTheOrderActivityState = {
  activity: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type GuessTheOrderActivityDispatch = undefined;
export type GuessTheOrderActivity = [GuessTheOrderActivityState, GuessTheOrderActivityDispatch];

export const GuessTheOrderActivity = (): { __typename: string } => ({
  __typename: StoreTypename.GUESS_THE_ORDER_ACTIVITY,
});

const useGuessTheOrderActivityStore = (
  bookCode: string,
  edition?: number
): GuessTheOrderActivity => {
  const { data, loading, error }: QueryResult<{ guessTheOrder: GuessTheOrder | undefined }> =
    useQuery(GET_GUESS_THE_ORDER_ACTIVITY, {
      variables: { where: { book: { bookCode, edition: edition || DEFAULT_BOOK_EDTION } } },
    });

  return [
    {
      activity: data?.guessTheOrder || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useGuessTheOrderActivityStore;
